import "@fontsource-variable/ibm-plex-sans";
import "@fontsource-variable/newsreader";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("The ProTV Converter root element is missing.");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
